import { actions } from './actions';
import { mutations } from './mutations';
var state = {
    group: null,
    groups: [],
    objectGroup: null,
    roles: [],
    loading: false,
};
export var userGroups = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
};
